import { Badge } from './ui/badge';
import { cn } from '../lib/utils';

const statusStyles = {
  // Idea statuses
  'Draft': 'bg-slate-100 text-slate-600 border-slate-200',
  'Submitted': 'bg-blue-50 text-blue-700 border-blue-200',
  'Under Review': 'bg-amber-50 text-amber-700 border-amber-200',
  'Approved': 'bg-emerald-50 text-emerald-700 border-emerald-200',
  'Rejected': 'bg-red-50 text-red-700 border-red-200',
  'Converted': 'bg-purple-50 text-purple-700 border-purple-200',
  
  // Project statuses
  'Not Started': 'bg-slate-100 text-slate-600 border-slate-200',
  'In Progress': 'bg-blue-50 text-blue-700 border-blue-200',
  'Blocked': 'bg-red-50 text-red-700 border-red-200',
  'Completed': 'bg-emerald-50 text-emerald-700 border-emerald-200',
  'Cancelled': 'bg-gray-100 text-gray-600 border-gray-200',
  
  // Approval statuses
  'Pending': 'bg-amber-50 text-amber-700 border-amber-200',
  
  // Effort estimates
  'Small': 'bg-emerald-50 text-emerald-700 border-emerald-200',
  'Medium': 'bg-amber-50 text-amber-700 border-amber-200',
  'Large': 'bg-red-50 text-red-700 border-red-200',
  
  // Complexity
  'Low': 'bg-emerald-50 text-emerald-700 border-emerald-200',
  'High': 'bg-red-50 text-red-700 border-red-200',
  
  // Confidence
  'Estimated': 'bg-slate-100 text-slate-600 border-slate-200',
  'Validated': 'bg-blue-50 text-blue-700 border-blue-200',
  'Realised': 'bg-emerald-50 text-emerald-700 border-emerald-200',
  
  // Idea types
  'Quick Win': 'bg-emerald-50 text-emerald-700 border-emerald-200',
  'Tech Project': 'bg-blue-50 text-blue-700 border-blue-200',
  'DMAIC': 'bg-purple-50 text-purple-700 border-purple-200',
};

const StatusBadge = ({ status, className }) => {
  const style = statusStyles[status] || 'bg-slate-100 text-slate-600 border-slate-200';
  
  return (
    <Badge 
      variant="outline" 
      className={cn(style, 'font-medium', className)}
    >
      {status}
    </Badge>
  );
};

export default StatusBadge;
